export default __webpack_public_path__ + "static/media/litho-demo-home-decor.999bab59.jpg";